<style lang="scss">
.zoezi-trainingcard-shop {
    .product-price {
        font-size: 1.25em;
    }

    .multisite-selection {
        font-size: 1.25em;
    }
}
.v-image.blur-img > .v-image__image{
    filter:blur(30px) !important;
    opacity:.4;
    transform:scale(1.2);
}
.v-card__title{
    word-break: normal;
}

</style>

<template>
    <div v-if="productsLoaded">
        <v-row v-if="hasMultiSites && showSiteFilter && !globalSiteSetting" @click="sitesMenuOpen = true">
            <v-col cols=12>
                <v-sheet color="primary" rounded class="primarytext--text multisite-selection pa-2">
                    <div class="d-flex">
                        <div class="flex-grow-1"><v-icon color="primarytext">mdi-map-marker-star-outline</v-icon><span>Visar utbud hos</span></div>

                        <div v-if="onlyShowOneSite">
                            {{$translate($store.state.settings.sites.find(x => x.id == selectedSiteId).name)}}
                        </div>

                        <v-menu v-else v-model="sitesMenuOpen">
                            <template v-slot:activator="{ on }">
                                <div v-on="on" class="z-clickable">{{$translate($store.state.settings.sites.find(x => x.id == selectedSiteId).name)}} <v-icon color="primarytext">mdi-chevron-down</v-icon></div>
                            </template>

                            <v-list>
                                <v-list-item class="z-clickable" v-for="site in selectableSites" :key="site.id" @click="setSite(site)">{{$translate(site.name)}}</v-list-item>
                            </v-list>
                        </v-menu>
                    </div>
                </v-sheet>
            </v-col>
        </v-row>

        <v-row v-if="$store.state.settings">
            <v-col cols=12>
                <webshop-categories-level
                    v-for="(categories, index) in categoryLevels"
                    :levelHasVisibleParent="index > 0"
                    :categories="categories"
                    :key="categoryLevelKey(categories)"
                    @selected="categorySelected($event)"
                />
            </v-col>
        </v-row>
        <v-row v-if="showTagsFilter">
            <v-col cols=12>
                <v-chip
                    v-for="tag in availableTags"
                    :key="tag.id"
                    :outlined="!tagsFilter.includes(tag.id)"
                    :close="tagsFilter.includes(tag.id)"
                    color="primary"
                    label
                    class="mr-2 mb-2"
                    @click="toggleTagFilter(tag.id)"
                    @click:close="toggleTagFilter(tag.id)"
                >
                    {{ tag.name }}
                </v-chip>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" sm="6" class="text--secondary d-flex align-center mb-2">
                <div v-if="showNumberOfItems && !shopLoading">{{selectedText}} - {{displayProductCount}} {{$translate('pcs')}}</div>
            </v-col>
            <v-col cols="12" sm="6">
                <v-row class="d-flex justify-space-between" v-if="searchQuery || displayProductCount > showSearchIfNumItems">
                    <v-col cols="8" class="pr-1">
                        <v-text-field
                            v-if="showSearch"
                            v-model="searchQuery"
                            :label="$translate('Search')"
                            @input="searchQuery = $event ? $event.toLowerCase() : ''"
                            prepend-inner-icon="mdi-magnify"
                            clearable
                        />
                    </v-col>
                    <v-col cols="4" class="pl-1">
                        <v-select
                            v-if="showSortOrder"
                            v-model="currentSortOrder"
                            :items="sortOptions"
                            :label="$translate('Sort by')"
                        />
                    </v-col>
                </v-row>
            </v-col>
        </v-row>

        <v-row v-if="usePaginatedShop && shopLoading" class="justify-center py-8">
            <v-progress-circular indeterminate color="primary" />
        </v-row>
        <v-row v-else>
            <v-col v-for="product in displayProducts"
                :key="product.id"
                class="pa-2 pa-md-4"
                cols="6" sm="6" md="4" lg="3"
            >
                <ItemCard :product="product"
                    :cropImage="cropImages"
                    @buyClick="buyClick"
                    @productClick="productClick"
                />
            </v-col>
        </v-row>
        <v-row v-if="usePaginatedShop && shopTotalCount > shopPageSize" class="justify-center mt-2 mb-4">
            <v-pagination v-model="shopPage" :length="Math.ceil(shopTotalCount / shopPageSize)" @input="fetchShopPage" total-visible="7" />
        </v-row>

        <training-card-product-dialog
            v-if="showingProduct"
            v-model="showingProduct"
            :product="showingProduct"
            :basket="checkoutItems"
            :site-id="selectedSiteId"
            :cropImage="cropImages"
            @buy="buyFromDialog"
        />

        <v-dialog
            v-model="switchSiteDialog.show"
            max-width="500"
        >
            <v-card v-if="switchSiteDialog.show">
                <v-card-title class="headline pa-2 primary primarytext--text d-flex fill-width">
                    {{$translate('Change store')}}
                    <v-spacer />
                    <v-btn icon @click="switchSiteDialog.show = false" ><v-icon class="primary primarytext--text">mdi-close</v-icon></v-btn>
                </v-card-title>
                <v-card-text class="mt-2">
                    <p>{{$translate('You are currently shopping in the store for')}} <span class="font-weight-bold">{{switchSiteDialog.fromSite.name}}</span>. {{$translate('If you switch to')}} <span class="font-weight-bold">{{switchSiteDialog.site.name}}</span> {{$translate('the following items will disappear from your shopping cart')}}:</p>

                    <div v-for="missing in switchSiteDialog.missing" :key="missing.product.id">
                        <v-icon color="error">mdi-cancel</v-icon>
                        <span class="font-weight-bold ml-2">{{missing.product.name}}</span>
                    </div>
                </v-card-text>

                <v-card-actions>
                    <v-spacer />
                    <v-btn color="primary" outlined @click="forceSetSite(); switchSiteDialog.show = false" class="zoezi-button-thin">{{$translate('Change store')}}</v-btn>
                    <v-btn color="primary" @click="switchSiteDialog.show = false" class="zoezi-button-thin">{{$translate('Continue shopping')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </div>
    <div v-else class="text-center">
        {{$translate('Loading...')}} <v-progress-circular indeterminate color="primary" />
    </div>
</template>

<script>
import WebshopCategoriesLevel from './WebshopCategoriesLevel.vue';
import TrainingCardProductDialog from '../components/TrainingCardProductDialog.vue'
import ItemCard from '../components/Shop/ItemCard';
import { getStockForProduct,makeValidPathFromTitle } from '../util';
import * as Sentry from '@sentry/browser';

export default {
    name: 'zoezi-shop',

    zoezi: {
        title: 'Shop',
        icon: 'mdi-cart-outline',
        addon: 'WebShop',
        getDefaultStyle: () => ({
            pageParams: [
                {
                    id: 'p',
                    prop: 'showProductTitle'
                }
            ]
        })
    },

    props: {
        onlyShowCategories: {
            title: 'Filter by categories',
            type: Array,
            fulltype: 'select',
            typeinfo: {
                getItems() {
                    return window.$zoeziapi.get('/api/public/settings/get').then(settings => {
                        return settings.webshopcategories.filter(c => !c.parent_id && !c.removed).sort((a,b) => a.name.localeCompare(b.name));
                    });
                },
                text: 'name',
                value: 'id',
                multiple: true
            },
            default: () => []
        },
        tagsFilter: {
            title: 'Filter by tags',
            type: Array,
            fulltype: 'select',
            typeinfo: {
                getItems() {
                    return window.$zoeziapi.get('/api/systemtag/get').then(all => {
                        return all;
                    });
                },
                text: 'name',
                value: 'id',
                multiple: true,
                placeholder: 'Show all tags'
            },
            default: () => []
        },
        initialSortOrder: {
            title: 'Sort order',
            type: String,
            fulltype: 'select',
            typeinfo: {
                getItems() {
                    return [
                        { id: 'name-asc', name: 'Name (A-Z)' },
                        { id: 'name-desc', name: 'Name (Z-A)' },
                        { id: 'price-asc', name: 'Price (Lowest to Highest)' },
                        { id: 'price-desc', name: 'Price (Highest to Lowest)' },
                        { id: 'stock-desc', name: 'Stock (Highest to Lowest)' }
                    ].map(x => ({...x, name: window.$translate(x.name)}));
                },
                text: 'name',
                value: 'id',
                multiple: false
            },
            default: () => 'name-asc'
        },
        showTagsFilter: {
            title: 'Show tags filter',
            type: Boolean,
            default: false
        },
        showSortOrder: {
            title: 'Show sort order',
            type: Boolean,
            default: true
        },
        showSearch: {
            title: 'Show search',
            type: Boolean,
            default: true
        },
        showSearchIfNumItems: {
            title: 'Show search only if number of items is greater than',
            type: Number,
            default: 6
        },
        showNumberOfItems: {
            title: 'Show number of items',
            type: Boolean,
            default: true
        },
        globalSiteSetting: {
            title: 'Filter by globally selected site',
            type: Boolean,
            default: true
        },
        onlyShowSites: {
            title: 'Filter by site',
            type: Array,
            fulltype: 'select',
            typeinfo: {
                getItems() {
                    return window.$zoeziapi.get('/api/public/settings/get').then(settings => {
                        return settings.sites.sort((a,b) => a.name.localeCompare(b.name));
                    });
                },
                text: 'name',
                value: 'id',
                multiple: true,
                placeholder: 'Show all sites',
                visible: '!globalSiteSetting'
            },
            default: () => []
        },
        showSiteFilter: {
            title: 'Show site filter',
            type: Boolean,
            default: false,
            visible: '!globalSiteSetting'
        },
        forceInfoDialog: {
            title: 'Always show product information dialog',
            type: Boolean,
            default: false
        },
        cartName: {
            title: 'Name of shopping cart',
            type: String,
            default: '',
            typeinfo: {
                placeholder: 'Use the standard shopping cart'
            }
        },
        cropImages: {
            title: 'Crop images towards the center (3:2)',
            type: Boolean,
            default: true
        },
        showProductId: {
            title: 'Show product - ID',
            type: Number
        },
        showProductTitle: {
            title: 'Show product - name',
            type: String
        },
        selectedCategoryId: {
            title: 'Selected category - ID',
            type: Number
        },
        selectedCategoryTitle: {
            title: 'Selected category - name',
            type: String
        }
    },

    components: {
        WebshopCategoriesLevel,
        TrainingCardProductDialog,
        ItemCard,
    },

    data: () => ({
        selectedSiteId: 1,
        showingProduct: null,
        showCheckout: false,
        almostdone: false,
        checkoutLoading: false,
        sitesMenuOpen: false,
        switchSiteDialog: {
            show: false,
            site: null,
            missing: []
        },
        selectedCategory: null,
        searchQuery: '',
        currentSortOrder: 'name-asc', // Default sort
        sortOptions: [
            { text: window.$translate('Name (A-Z)'), value: 'name-asc' },
            { text: window.$translate('Name (Z-A)'), value: 'name-desc' },
            { text: window.$translate('Price (Lowest to Highest)'), value: 'price-asc' },
            { text: window.$translate('Price (Highest to Lowest)'), value: 'price-desc' },
            { text: window.$translate('Stock (Highest to Lowest)'), value: 'stock-desc' },
        ],
        // Paginated shop state
        shopProducts: [],
        shopTotalCount: 0,
        shopPage: 1,
        shopPageSize: 24,
        shopLoading: false,
        _shopFetchTimer: null,
    }),

    watch: {
        '$store.state.selectedSiteId': {
            immediate: true,
            handler() {
                if (this.globalSiteSetting) {
                    this.selectedSiteId = this.$store.state.selectedSiteId;
                }
            }
        },
        selectedSiteId() {
            if (this.cart) {
                this.cart.site_id = this.selectedSiteId;
            }
        },
        onlyShowSites: {
            immediate: true,
            handler(sites) {
                if (this.globalSiteSetting) {
                    return;
                }
                const normalized = (sites || []).filter(site => site !== null && site !== undefined);
                if (normalized.length && !normalized.includes(this.selectedSiteId)) {
                    this.selectedSiteId = normalized[0];
                }
            }
        },
        showingProduct: {
            immediate: false,
            handler(showingProduct) {
                let id = showingProduct ? showingProduct.id : null;
                if (id != this.showProductId) {
                    this.setProp('showProductId', id);
                }
                let title = showingProduct ? makeValidPathFromTitle(showingProduct.name).substring(1) : null;
                if (title != this.showProductTitle) {
                    this.setProp('showProductTitle', title);
                }
            }
        },
        products(products) {
            if (products.length > 0) {
                this.$nextTick(() => {
                    if (this.showProductId) {
                        this.showingProduct = this.products.find(x => x.id == this.showProductId);
                    } else if (this.showProductTitle) {
                        this.showingProduct = this.products.find(x => makeValidPathFromTitle(x.name).substring(1) == this.showProductTitle);
                    }

                    if (this.selectedCategoryId) {
                        let cat = this.allCategories.find(x => x.id == this.selectedCategoryId)
                        if (cat) {
                            this.selectedCategory = cat;
                        }
                    } else if (this.selectedCategoryTitle) {
                        let cat = this.allCategories.find(x => {
                            let path = makeValidPathFromTitle(this.getCategoryPath(x)).substring(1);
                            if (path == this.selectedCategoryTitle) {
                                return true;
                            }
                        })
                        if (cat) {
                            this.selectedCategory = cat;
                        }
                    }
                });
            }
        },
        initialSortOrder: {
            immediate: true,
            handler(newSortOrder) {
                this.currentSortOrder = newSortOrder;
            }
        },
        // Paginated shop watchers — refetch when filters change
        selectedCategory() { this._debouncedShopFetch(); },
        searchQuery() { this._debouncedShopFetch(); },
        currentSortOrder() { if (this.usePaginatedShop) this.fetchShopPage(); },
    },

    computed: {
        usePaginatedShop() {
            return !!this.$api?.hasFlag?.('flag-price-rule-engine');
        },
        displayProducts() {
            return this.usePaginatedShop ? this.shopProducts : this.sortedProducts;
        },
        displayProductCount() {
            return this.usePaginatedShop ? this.shopTotalCount : this.filteredProducts.length;
        },
        products() {
            return this.$store.getters.allProducts.filter(p => {
                return p.customerCanBuy && p.type != 'course';
            });
        },
        productsLoaded() {
            return this.$store.state.productsLoaded;
        },
        cart() {
            if (!this.products || !this.products.length) {
                return null;
            }

            if (!this.$store.state.carts || !this.$store.state.carts[this.cartName]) {
                return null;
            }

            return this.$store.state.carts[this.cartName];
        },
        cartItems() {
            if (!this.cart) {
                return [];
            }

            return this.cart.items.map(x => {
                let item = {};
                Object.assign(item, x);
                item.product = this.products.find(p => p.id == x.product_id);
                return item;
            });
        },
        checkoutItems() {
            let res = this.cartItems.map(carti => {
                return {product_id: carti.product.id, count: carti.count, variant: carti.variant, price: carti.price};
            });
            return res;
        },
        hasMultiSites() {
            return this.$store.state.settings?.sites?.length > 1;
        },
        normalizedOnlyShowSites() {
            return (this.onlyShowSites || []).filter(site => site !== null && site !== undefined);
        },
        selectedText() {
            if (this.searchQuery) {
                return this.$translate('Search results');
            }
            if (!this.selectedCategory || (this.topCategory && this.selectedCategory.name === this.topCategory.name)) {
                return this.$translate('Displaying the full range');
            }

            let categoryLevel = this.selectedCategory;
            const categoryLevels = [categoryLevel.name];
            while (categoryLevel.parent != this.topCategory) {
                categoryLevel = categoryLevel.parent;
                categoryLevels.push(categoryLevel.name);
            }

            const reversedLevels =  categoryLevels.reverse();

            return reversedLevels.join(', ');
        },
        categoryLevels() {
            function getCategoryLevels(categories, topCategory, selectedCategory, onlyShowCategories) {
                const categoryLevels = [];
                let currentParent = selectedCategory ? selectedCategory : topCategory;
                let previousParent = null;

                // eslint-disable-next-line no-constant-condition
                while (true) {
                    let categoryLevel = categories.filter(category => {
                        if (!category.parent && onlyShowCategories && onlyShowCategories.length > 1 && !onlyShowCategories.find((showCategory) => showCategory === category.id)) {
                            return false;
                        }
                        return category.parent == currentParent
                    });

                    categoryLevel = categoryLevel.map(category => {
                        return { id: category.id, name: category.name, selected: category === previousParent, parent: category.parent };
                    });

                    if (categoryLevel.length > 0) {
                        const sortedCategoryLevel = categoryLevel.sort((a, b) => {
                            return  a.name < b.name ? -1 : 1;
                        });
                        categoryLevels.push(sortedCategoryLevel);
                    }

                    if (currentParent == topCategory) {
                        break;
                    }

                    previousParent = currentParent;
                    currentParent = currentParent.parent;
                }

                return categoryLevels.reverse();
            }

            if (!this.allCategories || this.allCategories.length === 0) {
                return [];
            }

            return getCategoryLevels(this.allCategories, this.topCategory, this.selectedCategory, this.onlyShowCategories);
        },
        filteredProductsPerSite() {
            const collectProductsForSites = (siteIds) => {
                let allFilteredProducts = [];
                siteIds.forEach(siteId => {
                    const productsForSite = this.getProductsForSite(siteId);
                    productsForSite.forEach(product => {
                        // Avoid duplicates if product is available on multiple selected sites
                        if (!allFilteredProducts.find(p => p.id === product.id)) {
                            allFilteredProducts.push(product);
                        }
                    });
                });
                return allFilteredProducts;
            };

            // If globalSiteSetting is true, use selectedSiteId
            if (this.globalSiteSetting) {
                return this.getProductsForSite(this.selectedSiteId);
            }

            // If onlyShowSites is specified, filter by those sites
            const normalizedSites = this.normalizedOnlyShowSites;
            if (normalizedSites.length > 0) {
                return collectProductsForSites(normalizedSites);
            }

            // If none of the above conditions are met, return all products
            return this.products || [];
        },
        filteredProductsOnTopCategory() {
            const products = this.filteredProductsPerSite;

            if (!this.onlyShowCategories || this.onlyShowCategories.length === 0) {
                return products;
            }

            function getCategoryObject(allCategories, categoryId) {
                if (!allCategories) {
                    return null;
                }
                return allCategories.find(category => category.id === categoryId);
            }

            function findTopCategory(categoryObject, topCategoriesToInclude) {
                if (!categoryObject.parent) {
                    return topCategoriesToInclude.find(category => category === categoryObject.id);
                }

                return findTopCategory(categoryObject.parent, topCategoriesToInclude);
            }

            function includedInActiveCategory(product, allCategories, topCategoriesToInclude) {
                const productCategoryObject = getCategoryObject(allCategories, product.product_webshop_category_id);
                if (!productCategoryObject) {
                    return false;
                }
                return findTopCategory(productCategoryObject, topCategoriesToInclude)
            }

            function getFilteredProducts(products, allCategories, topCategoriesToInclude) {
                return products.filter((product) => includedInActiveCategory(product, allCategories, topCategoriesToInclude));
            }

            const filteredProducts = getFilteredProducts(products, this.allCategories, this.onlyShowCategories);

            return filteredProducts;
        },
        allCategories() {
            return this.$store.state.settings?.webshopcategories.filter(x => !x.removed);
        },
        topCategories() {
            return this.allCategories.filter(x => !x.parent_id);
        },
        availableTags() {
            let tags = [];
            this.filteredProductsPerSite.forEach(product => {
                if (product.tags) {
                    product.tags.forEach(tag => {
                        if (!tags.find(x => x.id === tag.id)) {
                            tags.push(tag);
                        }
                    });
                }
            });
            return tags.sort((a, b) => a.name.localeCompare(b.name));
        },
        filteredProducts() {
            let products = this.filteredProductsOnTopCategory;
            
            if (this.tagsFilter && this.tagsFilter.length) {
                products = products.filter(product => {
                    if (!product.tags || !product.tags.length) return false;
                    return product.tags.some(tag => this.tagsFilter.includes(tag.id));
                });
            }
            if (!this.selectedCategory) {
                return this.filterBySearchQuery(products);
            }

            function findInParentCategory(productCategory, category) {
                if (!productCategory) {
                    return false;
                }
                if (productCategory.id === category.id) {
                    return true;
                }
                if (!productCategory.parent) {
                    return false;
                }
                return findInParentCategory(productCategory.parent, category);
            }

            function getCategoryObject(allCategories, categoryId) {
                if (!allCategories) {
                    return null;
                }
                return allCategories.find(category => category.id === categoryId);
            }

            const productsToShow = products.filter((product) => {
                if (product.product_webshop_category_id === this.selectedCategory.id) {
                    return true;
                }
                const categoryObject = getCategoryObject(this.allCategories, this.selectedCategory.id);
                const productCategoryObject = getCategoryObject(this.allCategories, product.product_webshop_category_id);
                return findInParentCategory(productCategoryObject, categoryObject);
            });

            return this.filterBySearchQuery(productsToShow);
        },
        selectableSites() {
            const allSites = this.$store.state?.settings?.sites;
            if (!allSites) {
                return [];
            }

            const normalizedSites = this.normalizedOnlyShowSites;
            if (normalizedSites.length == 0) {
                return allSites;
            }

            return allSites.filter(site => normalizedSites.includes(site.id));
        },
        onlyShowOneSite() {
            return this.normalizedOnlyShowSites.length == 1;
        },
        topCategory() {
            if (this.onlyShowCategories && this.onlyShowCategories.length === 1) {
                return this.allCategories.find(category => category.id === this.onlyShowCategories[0]);
            } else if (this.topCategories && this.topCategories.length === 1) {
                return this.topCategories[0];
            }
            return null;
        },
        sortedProducts() {
            let sorted = [...this.filteredProducts];
            switch (this.currentSortOrder) {
                case 'name-asc':
                    sorted.sort((a, b) => (a.name.toLowerCase().localeCompare(b.name.toLowerCase(), undefined, { numeric: true })));
                    break;
                case 'name-desc':
                    sorted.sort((a, b) => (b.name.toLowerCase().localeCompare(a.name.toLowerCase(), undefined, { numeric: true })));
                    break;
                case 'price-asc':
                    sorted.sort((a, b) => a.price - b.price);
                    break;
                case 'price-desc':
                    sorted.sort((a, b) => b.price - a.price);
                    break;
                case 'stock-desc':
                    sorted.sort((a, b) => {
                        const aStock = a.stock === null ? Infinity : a.stock;
                        const bStock = b.stock === null ? Infinity : b.stock;
                        return bStock - aStock;
                    });
                    break;
                default:
                    sorted.sort((a, b) => a.id - b.id);
                    break;
            }
            return sorted;
        }
    },

    methods: {
        _debouncedShopFetch() {
            if (!this.usePaginatedShop) return;
            clearTimeout(this._shopFetchTimer);
            this.shopLoading = true;
            this._shopFetchTimer = setTimeout(() => {
                this.shopPage = 1;
                this.fetchShopPage();
            }, 300);
        },
        fetchShopPage() {
            if (!this.usePaginatedShop) return;
            this.shopLoading = true;

            const data = {
                page: this.shopPage,
                page_size: this.shopPageSize,
                sort: this.currentSortOrder,
            };
            if (this.searchQuery) data.search = this.searchQuery;
            if (this.selectedCategory) data.category_id = this.selectedCategory.id;
            if (this.selectedSiteId) data.site_id = this.selectedSiteId;
            if (this.tagsFilter && this.tagsFilter.length) data.tags = this.tagsFilter;
            if (this.onlyShowCategories && this.onlyShowCategories.length) data.top_categories = this.onlyShowCategories;

            this.$api.post('/api/public/pricerule/shop', data).then(r => {
                if (!r.ok) {
                    this.shopLoading = false;
                    return;
                }
                r.json().then(result => {
                    this.shopProducts = result.products || [];
                    this.shopTotalCount = result.total_count || 0;
                    this.shopLoading = false;
                });
            }).catch(() => {
                this.shopLoading = false;
            });
        },
        productDescription(html){
            if(html) {
                html = html.replace(/(<([^>]+)>)/gi, "");
                if(html.length>100) html = html.substr(0, 100).trim() + '…';
            }
            return html;
        },
        needsToChooseVariant(product) {
            if (!product.variants || !product.variants.length) {
                return false;
            }
            const variants = product.variants;
            if (variants.length > 1) {
                return true;
            }
            const firstVariant = variants[0];
            return firstVariant.name && firstVariant.name !== 'Standard';
        },
        hasIncludedProductsRequiringVariant(product) {
            if (!product.included_products || !product.included_products.length) return false;
            let allProducts = this.$store.getters.allProducts;
            return product.included_products.some(id => {
                let p = allProducts.find(pp => pp.id == id);
                return p && p.variants && p.variants.length > 1;
            });
        },
        buyClick(product) {
            if (this.forceInfoDialog || this.needsToChooseVariant(product) || product.payWhatYouWant) {
                this.productClick(product)
            } else {
                this.buy(product);
            }
        },
        productClick(product) {
            this.showingProduct = product;

            try {
                let ecommerceTrackingItem = {
                    id: 'p' + product.id,
                    name: product.name,
                    price: product.price,
                    vat: product.vat,
                };
                this.$ecommercetracking.viewItem(ecommerceTrackingItem);
            } catch(error) {
                Sentry.captureException(error);
            }
        },
        categorySelected(selected) {
            const selectedCategory = this.allCategories.find(category => category.id === selected.id);
            this.selectedCategory = selected.selected ? (selectedCategory.parent ? selectedCategory.parent : null) : selectedCategory;
            this.setProp('selectedCategoryId', this.selectedCategory ? this.selectedCategory.id : null)
            let title = this.selectedCategory ? makeValidPathFromTitle(this.getCategoryPath(this.selectedCategory)).substring(1) : null
            this.setProp('selectedCategoryTitle', title)
        },
        toggleTagFilter(tagId) {
            const filter = [...this.tagsFilter];
            const index = filter.indexOf(tagId);
            if (index >= 0) {
                filter.splice(index, 1);
            } else {
                filter.push(tagId);
            }
            this.setProp('tagsFilter', filter);
        },
        categoryLevelKey(categories) {
            const categoryNames = categories.map((category) => category.name);
            return categoryNames.join(', ');
        },
        buy(product) {
            this.addToCart({product});
        },
        addToCart({product, count, variant, price, variants_for_included_products}) {
            count = count || 1;
            this.$store.dispatch('addToCart', {cartName: this.cartName, product_id: product.id, count, variant, price, site_id: this.selectedSiteId, variants_for_included_products});
            this.$store.dispatch('setCartVisibility', {cartName: this.cartName, showBottomBar: true, showCheckout: false});
        },
        changeNumberOfItems(item, count) {
            this.$store.dispatch('changeItemCountInBasket', {basketName: this.cartName, product_id: item.product_id, variant: item.variant, count});
        },
        buyFromDialog({product, count, variant, price, variants_for_included_products}) {
            this.addToCart({product, count, variant, price, variants_for_included_products});
            this.showingProduct = null;
        },
        /* Returns a list of products in cart which are not available or are out of stock on specified site */
        getProductsMissingFromSite(site) {
            let products = this.getProductsForSite(site.id);
            let missing = this.cartItems.filter(item => {
                if (!products.find(p => p.id == item.product.id)) {
                    return true;
                }

                let stock = getStockForProduct(item.product, item.variant, site.id);
                if (stock === undefined || stock < item.count) {
                    return true;
                }

                return false;
            })

            return missing;
        },
        getProductsForSite(siteId) {
            let tcards = this.products;
            if (this.hasMultiSites) {
                return tcards.filter(x => {
                    if(x.type == 'membership') {
                        return true;
                    }
                    let isTrainingCard = x.type == 'trainingcard';
                    let prop = isTrainingCard ? 'sites' : 'visible_sites'
                    let sites = x[prop];
                    return !sites || sites.length == 0 || sites.includes(siteId)
                })
            } else {
                return tcards;
            }
        },
        setSite(site) {
            let missing = this.getProductsMissingFromSite(site);
            if (missing.length) {
                // Show confirm switch site-dialog
                this.switchSiteDialog.show = true;
                this.switchSiteDialog.fromSite = this.$store.state.settings.sites.find(x => x.id == this.selectedSiteId);
                this.switchSiteDialog.site = site;
                this.switchSiteDialog.missing = missing;
            } else {
                this.selectedSiteId = site.id;
            }
        },
        forceSetSite() {
            this.$store.dispatch('removeCart', {cartName: this.cartName});

            this.switchSiteDialog.missing.forEach(item => {
                this.$store.dispatch('changeItemCountInCart', {cartName: this.cartName, product_id: item.product_id, variant: item.variant, count: 0})
            })

            this.cart.site_id = this.switchSiteDialog.site.id;
        },
        clearCart() {
            this.$store.dispatch('removeBasket', {basketName: this.cartName})
        },
        getCategoryPath(cat) {
            let res = '';
            if (cat.parent) {
                res += this.getCategoryPath(cat.parent) + '-';
            }
            return res + cat.name;
        },
        calculateAndFormatEndDate(date) {
            let dateObj = Date.newFull(date);
            dateObj.setDate(dateObj.getDate() - 1);
            return Date.formatFullShorter(dateObj);
        },
        filterBySearchQuery(products) {
            return this.searchQuery ? products.filter(product => product.name.toLowerCase().includes(this.searchQuery)): products;
        }
    },
    mounted() {
        this.$store.dispatch('loadProducts');

        // Fetch paginated shop if price rules are enabled
        if (this.usePaginatedShop) {
            this.fetchShopPage();
        }

        // When this component is shown - show bottom bar if cart has items
        let cart = this.$store.state.carts?.[this.cartName];
        if (cart && cart.items.length && !cart.showBottomBar && !cart.showCheckout) {
            this.$store.dispatch('setCartVisibility', {cartName: this.cartName, showBottomBar: true, showCheckout: false});
        }
    },
    destroyed() {
        // When this component is hidden - hide bottom bar (leaving page)
        if (this.cart?.showBottomBar || this.cart?.showCheckout) {
            this.cart.showBottomBar = false;
            this.cart.showCheckout = false;
        }
    }
}
</script>
